export enum ModuleType {
  ORDER = "order",
  PRODUCT = "product",
  INVENTORY = "inventory",
  CUSTOMER = "customers",
  USER = "user",
  ADMIN = "admin",
  PROJECT_MANAGEMENT = "project_management",
  PURCHASE_REQUEST = "purchase_request",
  URGENT_SOURCING = "urgent_sourcing",
}

export interface ModuleTasks {
  id: number;
  module_id: number;
  task: string;
  active: boolean;
  created_date: Date;
  modified_date: Date;
  ops_sync_label?: string;
  custimisation_related?: boolean;
  is_product_level?: boolean;
}
